<script>
export default {
  name: "FullpageProgressBar"
}
</script>

<template>
  <v-container fluid fill-height align-center justify-center>
        <v-progress-circular
            color="ddblue"
            size="120"
            width="6"
            absolute
            indeterminate
        ></v-progress-circular>
  </v-container>
</template>

<style scoped>

</style>